<template>
  <v-app id="inspire">
    <v-app-bar app :color="editMode ? 'primary' : 'secondary'" dark>
      <v-spacer></v-spacer>
      <template v-if="editMode">
        <v-btn icon @click.stop="editMode = !editMode">
          <v-icon>mdi-cancel</v-icon>
        </v-btn>
        <v-btn icon @click.stop="editMode = !editMode">
          <v-icon>mdi-content-save-outline</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn icon hidden>
          <v-icon>mdi-calendar</v-icon>
        </v-btn>
        <v-btn icon @click.stop="reset">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon @click.stop="editMode = !editMode">
          <v-icon>mdi-circle-edit-outline</v-icon>
        </v-btn>
      </template>
    </v-app-bar>
    <v-content>
      <v-container>
        <v-snackbar v-model="snackbar" :timeout="timeout" color="success" top>
          {{ snacktext }}
          <v-btn color="white" icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
        <v-row align="start" justify="start" class="apphead">
          <div class="today">Today is</div>
          <div class="dow">{{ dow }}</div>
          <h1 class="title">Have I...?</h1>
        </v-row>
        <v-row align="start" justify="start">
          <v-col class="text-center">
            <draggable
              class="list-group"
              tag="v-list"
              handle=".handle"
              v-model="message"
              v-bind="dragOptions"
              @start="isDragging = true"
              @end="saveList"
              v-if="showList"
            >
              <v-list-item
                class="list-group-item"
                v-for="element in message"
                :key="element.order"
              >
                <v-list-item-icon class="handle">
                  <v-icon>mdi-drag-horizontal-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="element.name"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click.stop="editItem(element)">
                    <v-icon color="grey lighten-1">mdi-pencil</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon @click.stop="deleteItem(element)">
                    <v-icon color="grey lighten-1">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </draggable>
            <div v-else-if="editMode">
              <h2>Use the Add button below to add your first item.</h2>
            </div>
            <v-list v-else class="list-group">
              <v-list-item
                class="list-group-item"
                v-for="element in message"
                :key="element.order"
              >
                <v-list-item-content>
                  <v-btn
                    tile
                    :outlined="!element.done"
                    :depressed="element.done"
                    color="secondary"
                    large
                    @click.stop="toggle(element)"
                  >
                    {{ element.name }}
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-bottom-navigation
      :value="activeBtn"
      color="purple lighten-1"
      v-if="editMode"
    >
      <v-btn @click.stop="addItem">
        <span>Add</span>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn @click.stop="editMode = !editMode">
        <span>Cancel</span>
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
      <v-btn @click.stop="editMode = !editMode">
        <span>Save</span>
        <v-icon>mdi-content-save-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="currentEdit"
                  label="Have I"
                  required
                  append-icon="mdi-help"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.stop="saveItem">Save</v-btn>
          <v-btn text @click.stop="dialog = !dialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import draggable from "vuedraggable";
import compliments from "@/assets/compliments.js";

export default {
  components: {
    draggable
  },
  props: {
    source: String
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    list() {
      return this.message.map((name, index) => {
        return { name, order: index + 1 };
      });
    },
    showList() {
      return this.editMode && this.message.length > 0;
    },
    dow() {
      let now = new Date();
      let options = { weekday: "long" };
      return new Intl.DateTimeFormat(navigator.language, options).format(now);
    }
  },
  data: () => ({
    drawer: null,
    editMode: false,
    activeBtn: 1,
    message: [],
    adding: false,
    editing: false,
    currentID: 0,
    dialog: false,
    currentEdit: "",
    snackbar: false,
    snacktext: "",
    timeout: 2000
  }),
  mounted: function() {
    let message = localStorage.getItem("havei-message");
    if (message) {
      this.message = JSON.parse(message);
    }
    if (this.message.length == 0) {
      this.editMode = true;
    }
  },
  methods: {
    addItem: function() {
      this.adding = true;
      this.dialog = true;
    },
    editItem: function(item) {
      console.log("edit item", item.name, item.order);
      this.editing = true;
      this.currentID = item.order;
      this.currentEdit = item.name;
      this.dialog = true;
    },
    deleteItem: function(item) {
      let idx = item.order;
      this.message.splice(idx, 1);
      this.saveList();
    },
    saveItem: function() {
      if (this.currentEdit != "") {
        if (this.adding) {
          this.message.push({
            name: this.currentEdit,
            order: this.message.length,
            done: false
          });
        } else {
          this.message[this.currentID].name = this.currentEdit;
        }
      }
      this.dialog = false;
      this.adding = false;
      this.editing = false;
      this.currentId = false;
      this.currentEdit = "";
    },
    saveList: function() {
      let newMessage = [];
      this.message.forEach(function(item, idx) {
        item.order = idx;
        newMessage.push(item);
      });
      this.message = newMessage;
    },
    toggle: function(item) {
      item.done = !item.done;
      this.message[item.order] = item;
      this.storeList();
      this.success();
    },
    storeList: function() {
      localStorage.setItem("havei-message", JSON.stringify(this.message));
    },
    success: function() {
      this.snacktext =
        compliments[Math.floor(Math.random() * compliments.length)];
      this.snackbar = true;
    },
    reset: function() {
      let newMessage = [];
      this.message.forEach(function(item) {
        item.done = false;
        newMessage.push(item);
      });
      this.message = newMessage;
      this.storeList();
    }
  }
};
</script>

<style lang="scss">
.today,
.dow,
.title {
  display: block;
  width: 100%;
  text-align: center;
}

.v-application .apphead .title {
  font-size: 2rem !important;
}
.today {
  margin-bottom: 0px;
  font-size: 0.75rem;
}
.dow {
  font-size: 1.25rem;
  margin-bottom: 8px;
  margin-top: -2px;
}
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>
